import "./App.css";
import LoginView from "views/unauthenticated/LoginView";
import Layout from "views/authenticated/Layout";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";

import { useMessageCtx } from "context/MessageContext";
import { MessageAlert } from "components/MessageAlert";
import { AuthContext } from "context/AuthContext";
import PrivateRoute from "routes/Private.Routes";
import PublicRoute from "routes/Public.Route";
import { Route, Routes } from "react-router";
import Admin from "views/authenticated/Admin";
import Organisation from "views/authenticated/Organisation";
import WorkOrders from "views/authenticated/WorkOrders";
import ErrorView from "views/404";

function App() {
  axios.defaults.baseURL = process.env.REACT_APP_API_URL;
  axios.defaults.withXSRFToken = true;
  axios.defaults.headers.post["Content-Type"] = "application/json";

  const { messages } = useMessageCtx();
  return (
    <AuthContext>
      {messages.length > 0 && (
        <div className="alert-container">
          {messages.map((m) => (
            <MessageAlert key={m._id} {...m} />
          ))}
        </div>
      )}
      <div
        className="App "
        style={{
          fontFamily: "Montserrat", //Global Fonts
        }}
      >
        <Routes>
          <Route element={<PublicRoute />}>
            <Route path="/login" element={<LoginView />} />
          </Route>
          <Route element={<PrivateRoute />}>
            <Route element={<Layout />}>
              <Route path="/" element={<WorkOrders />} />
              <Route path="/oversikt" element={<Admin />} />
              <Route path="/organisation" element={<Organisation />} />
            </Route>
          </Route>
          <Route path="*" element={<ErrorView />} />
        </Routes>
      </div>
    </AuthContext>
  );
}

export default App;
